export enum Delay {
  XSmall = 500,
  Small = 1000,
  Medium = 2000,
  Large = 5000,
}
